<span
	*ngFor="let i of rate | range"
	class="star"
	[style.font-size.px]="size"
	[style.background-image]="'url(' + icon + ')'"
></span>
